<div class="wrapper">
  <div class="header">
    <div class="heading">
      {{ heading }}
    </div>
    @if (subheading) {
      <div
        class="subheading"
        >
        {{ subheading }}
      </div>
    }

  </div>

  <div
    class="section content"
    [class]="testType"
    >
    @if (testType === 'internal') {
      <app-onsite-tests
        class="section"
        [data]="data"
        />
    }
    @if (testType === 'external') {
      <app-offsite-tests
        class="section"
        [data]="data"
        />
    }
  </div>
</div>
